import React from "react";
import { TextField } from "@mui/material";

/**
 * A controlled text field that keeps a local copy of `value` while focused,
 * so the parent form doesn't re-render it on every keystroke.
 * Shared across WageMapping and AddDeductTaxMapping modules.
 */
function LocalTextField({ value, onValueChange, onValueBlur, clearOnFocusZero, ...props }) {
    const [localValue, setLocalValue] = React.useState(value ?? "");
    const [isFocused, setIsFocused] = React.useState(false);
    const hasTypedRef = React.useRef(false);

    React.useEffect(() => {
        if (!isFocused) {
            setLocalValue(value ?? "");
        }
    }, [value, isFocused]);

    return (
        <TextField
            {...props}
            title={localValue}
            value={localValue}
            onChange={(e) => {
                hasTypedRef.current = true;
                const val = e.target.value;
                if (onValueChange && onValueChange(val) === false) return;
                setLocalValue(val);
            }}
            onBlur={(e) => {
                setIsFocused(false);
                let finalVal = localValue;
                if (!hasTypedRef.current && (localValue === "" || localValue === undefined)) {
                    finalVal = value ?? "";
                    setLocalValue(finalVal);
                }
                if (onValueBlur) onValueBlur(finalVal);
                if (props.onBlur) props.onBlur(e);
            }}
            onFocus={(e) => {
                setIsFocused(true);
                hasTypedRef.current = false;
                const isNumericZero = Number(localValue) === 0;
                const isTimeZero = String(localValue).trim() === "0:00";
                const isDecimalZero = String(localValue).trim() === "0.00";

                if (clearOnFocusZero && (isNumericZero || isTimeZero || isDecimalZero)) {
                    setLocalValue("");
                }
                if (props.onFocus) props.onFocus(e);
            }}
        />
    );
}

export default LocalTextField;
